// The `health` feature's data adapters (Frontend §5.4): one component tree over #29 / #30 (clinic app: C-12, the PF
// card) or #52 / #60 `?clinicId=` (admin app: the S-04 Health tab).
import type { ClinicHealth, IncidentPage } from '@pa/api/clinic'
import { useAdminGetClinicHealth, useAdminListIncidents } from '@pa/api/admin'
import { useGetClinicHealth, useListClinicIncidents } from '@pa/api/clinic'
import { keepPreviousData } from '@tanstack/react-query'
import type { QueryLike } from '../../errors/hooks/adapters'

/** C-12 refreshes its state every minute while open (the probe's cadence). */
export const HEALTH_POLL_MS = 60_000

export interface HealthAdapter {
  useHealth: () => QueryLike<ClinicHealth>
  useIncidents: (page: number) => QueryLike<IncidentPage>
}

const pageParams = (page: number) => (page > 1 ? { page: String(page) } : {})

/** C-12: #29 (90 days) and #30 (20 per page). */
export function clinicHealthAdapter(clinicId: string): HealthAdapter {
  return {
    useHealth: () => useGetClinicHealth(clinicId, {}, { query: { refetchInterval: HEALTH_POLL_MS } }),
    useIncidents: (page) =>
      useListClinicIncidents(clinicId, pageParams(page), { query: { placeholderData: keepPreviousData } }),
  }
}

/** The S-04 Health tab: #52 and #60 with `?clinicId=`. */
export function adminHealthAdapter(clinicId: string): HealthAdapter {
  return {
    useHealth: () => useAdminGetClinicHealth(clinicId, {}, { query: { refetchInterval: HEALTH_POLL_MS } }),
    useIncidents: (page) =>
      useAdminListIncidents({ clinicId, ...pageParams(page) }, { query: { placeholderData: keepPreviousData } }),
  }
}
